export default "__VITE_ASSET__Diz8s08l__"